import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import EditTextParamButton from '../atoms/EditTextParamButton';
import StripeButton from '../atoms/StripeButton';
import CheckInvalidButton from '../atoms/CheckInvalidButton';
import CheckOkButton from '../atoms/CheckOkButton';

const styles = {};

const enhance = compose(pure);

const DepositRegisterTableBody = enhance(
  ({ shops, emptyRows, page, rowsPerPage, editOpenAction }) => {
    return (
      <TableBody>
        {shops
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const params = {
              shopId: shop.shopId,
              updatedAt: shop.updatedAt
            };
            const key = `${shop.groupId}-${shop.shopId}`;
            const depositBtnType =
              shop.depositManage === 'SELF' ? (
                <StripeButton />
              ) : (
                <CheckInvalidButton />
              );
            return (
              <TableRow key={key}>
                <TableCell>
                  <EditTextParamButton
                    params={params}
                    onClickAction={editOpenAction}
                  />
                </TableCell>
                <TableCell>
                  {shop.depositManage === 'NOT_MANAGE' && '※未設定'}
                  {shop.depositManage === 'NONSELF' && '月一回の振込み'}
                  {shop.depositManage === 'SELF' &&
                    '自社で入金を管理する（オプション）'}
                </TableCell>
                <TableCell>
                  {shop.accountStatus.stripeAccount ? (
                    <CheckOkButton />
                  ) : (
                    depositBtnType
                  )}
                </TableCell>
                <TableCell>{shop.shopName}</TableCell>
                <TableCell>
                  {shop.prefectures}
                  {` `}
                  {shop.city}
                  {` `}
                  {shop.address}
                  {` `}
                  {shop.building}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(DepositRegisterTableBody);
